import { render, staticRenderFns } from "./FwBadge.vue?vue&type=template&id=b5060912"
import script from "./FwBadge.vue?vue&type=script&lang=ts"
export * from "./FwBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports